/**
 * Size Toggle Component
 * Controls visibility of US size options in product variant selectors
 */
if (!customElements.get('size-toggle')) {
  class SizeToggle extends HTMLElement {
    constructor() {
      super();
      // Wait for DOM to be ready before initialization
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      // Create toggle switch element with inline styles for maximum compatibility
      this.toggle = document.createElement('div');
      this.toggle.style.margin = '12px 0 6px 0';
      this.toggle.style.padding = '3px 0';
      this.toggle.style.width = '100%';
      this.toggle.style.fontFamily = 'inherit';
      
      this.toggle.innerHTML = `
        <label style="display: inline-flex; align-items: center; cursor: pointer;">
          <span style="font-size: .88em; font-weight: 700;">Show US Sizes</span>
          <div style="position: relative; display: inline-block; width: 32px; margin-left: 8px; vertical-align: middle;">
            <input type="checkbox" class="toggle-input" style="position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;">
            <div class="toggle-bg" style="display: block; height: 18px; width: 32px; background-color: #f7ddea; border-radius: 9999px; transition: background-color 0.2s;"></div>
            <div class="toggle-dot" style="position: absolute; left: 3px; top: 3px; width: 12px; height: 12px; background-color: #e58fb8; border-radius: 9999px; transition: transform 0.2s;"></div>
          </div>
        </label>
      `;

      // Get checkbox input and add event listener
      this.checkbox = this.toggle.querySelector('.toggle-input');
      this.toggleBg = this.toggle.querySelector('.toggle-bg');
      this.toggleDot = this.toggle.querySelector('.toggle-dot');
      
      this.checkbox.addEventListener('change', this.handleToggle.bind(this));

      // Find variant selectors and check if we need to add toggle
      this.findAndProcessVariantSelectors();
    }

    findAndProcessVariantSelectors() {
      // Wait a moment to ensure custom elements are defined and rendered
      setTimeout(() => {
        console.log('Checking for size selectors...');
        
        // Look for the variant-picker component
        const variantPicker = document.querySelector('variant-picker');
        if (!variantPicker) {
          console.log('No variant-picker found');
          return;
        }
        
        // Find ALL option selectors
        const optionSelectors = variantPicker.querySelectorAll('.option-selector');
        if (!optionSelectors || optionSelectors.length === 0) {
          console.log('No option selectors found');
          return;
        }
        
        // Find the size selector from all option selectors
        let sizeSelector = null;
        for (let i = 0; i < optionSelectors.length; i++) {
          const label = optionSelectors[i].querySelector('.label');
          if (label && label.textContent.trim().toLowerCase() === 'size') {
            sizeSelector = optionSelectors[i];
            break;
          }
        }
        
        if (!sizeSelector) {
          console.log('No size selector found');
          return;
        }
        
        console.log('Found size selector');
        
        // Find the custom-select component
        const customSelect = sizeSelector.querySelector('custom-select');
        if (!customSelect) {
          console.log('No custom-select found');
          return;
        }
        
        // Find all options in the dropdown
        const options = customSelect.querySelectorAll('.custom-select__option');
        if (!options || options.length === 0) {
          console.log('No options found');
          return;
        }
        
        console.log('Found ' + options.length + ' options');
        
        const usSizeOptions = [];
        const usKeywords = ['california', 'cali', 'usa', 'us '];
        
        // Check each option to see if it's a US size
        options.forEach(option => {
          const optionSpan = option.querySelector('span');
          if (!optionSpan) return;
          
          const optionText = optionSpan.textContent.trim().toLowerCase();
          console.log('Option text: ' + optionText);
          
          // Check if the option contains any US keywords
          const isUSSize = usKeywords.some(keyword => optionText.includes(keyword));
          
          if (isUSSize) {
            console.log('Found US size: ' + optionText);
            usSizeOptions.push(option);
            // Store original display value
            option.dataset.originalDisplay = option.style.display || '';
            // Initially hide US size options
            option.style.display = 'none';
          }
        });
        
        // Only add toggle if US size options were found
        if (usSizeOptions.length > 0) {
          this.sizeOptions = usSizeOptions;
          
          // Insert toggle AFTER the custom-select component
          sizeSelector.appendChild(this.toggle);
          console.log('Size toggle added with ' + usSizeOptions.length + ' US size options');
        } else {
          console.log('No US size options found');
        }
      }, 800); // Increase timeout for slower sites
    }

    handleToggle(event) {
      const showUSSizes = event.target.checked;
      
      // Update toggle appearance
      if (showUSSizes) {
        this.toggleBg.style.backgroundColor = '#6e683b'; // Custom active color
        this.toggleDot.style.transform = 'translateX(14px)'; // Adjusted for smaller toggle
      } else {
        this.toggleBg.style.backgroundColor = '#f7ddea'; // Much lighter pink, subtle and soft
        this.toggleDot.style.transform = 'translateX(0)';
      }
      
      if (this.sizeOptions && this.sizeOptions.length > 0) {
        this.sizeOptions.forEach(option => {
          if (showUSSizes) {
            option.style.display = option.dataset.originalDisplay;
          } else {
            option.style.display = 'none';
          }
        });
        
        console.log('Toggle changed: ' + (showUSSizes ? 'showing' : 'hiding') + ' US sizes');
        
        // Try to update the dropdown
        const customSelectBtn = document.querySelector('.custom-select__btn');
        if (customSelectBtn && customSelectBtn.getAttribute('aria-expanded') === 'true') {
          // If the dropdown is open, close it
          customSelectBtn.click();
        }
      }
    }
  }

  customElements.define('size-toggle', SizeToggle);
}

// Initialize size toggle when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Create and add the size toggle component
  const sizeToggle = document.createElement('size-toggle');
  document.body.appendChild(sizeToggle);
  
  console.log('Size toggle component initialized');
});
